import { useState, useEffect } from 'react';

const useScrollDirection = () => {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const handleScroll = () => {
      const currentScrollY = window.pageYOffset;
      
      // 최상단(10px 이하)에 도달하면 헤더 보이기
      if (currentScrollY <= 10) {
        setIsHidden(false);
      }
      // 100px 이상 스크롤하면 헤더 숨기기
      else if (currentScrollY > 100) {
        setIsHidden(true);
      }
      
      lastScrollY = currentScrollY;
    };

    // 초기 상태 설정
    if (window.pageYOffset > 100) {
      setIsHidden(true);
    }

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { isHidden };
};

export default useScrollDirection;